import Popup from "./popup";
import FormValidation from "./form-validation";
import Tabs from "./tabs";
import ModalImageVideoSlider from "./modal-image-video-slider";
import { messageBoxSuccess, messageBoxError } from './message-box';

type SelectOptionTemplates = {
    [key: string]: HTMLTemplateElement
}

class FormPopup extends Popup {
  public formPopup: HTMLElement | null;
  public formTitleEl: HTMLElement | null;
  public formContentEl: HTMLElement | null;
  public formSuccessEl: HTMLElement | null;
  public isSending: Boolean = false;
  public createAccount: Boolean = false;
  public showRequiredAccessoriesMessageBox: Boolean = true;

  public formToggleTrigger: HTMLElement | null | undefined = null;
  public formToggleTarget: NodeListOf<HTMLElement> | null | undefined = null;
  public formOpenTrigger: HTMLElement | null | undefined = null;
  public formOpenTarget: HTMLElement | null | undefined = null;
  public successCloseBtn: NodeListOf<HTMLElement> | null | undefined = null;
  public createAccountCheckbox: HTMLElement | null | undefined = null;

  public inputCompany: HTMLInputElement | null | undefined = null;
  public buttonTabs: NodeListOf<HTMLButtonElement> | null | undefined = null;
  public tabColumn: HTMLElement | null | undefined = null;

  public cartIconHeader: HTMLElement | null;
  public cartIconHeaderInner: SVGTSpanElement | null | undefined;

  public uploadButtons: NodeListOf<HTMLInputElement> | undefined;
  public addUploadButton: HTMLElement | null;
  public removeUploadButtons: NodeListOf<HTMLButtonElement> | undefined;
  public cachedFileInput: Node | undefined;

  public customerDeliveryAddressToggle: HTMLInputElement | null | undefined = null;
  public customerProjectContactToggles: NodeListOf<HTMLInputElement> | undefined;

  private showroomLocationInputs: NodeListOf<HTMLInputElement> | null;
  private showroomTimeSelect: HTMLSelectElement | null;
  private showroomTimeOptions: SelectOptionTemplates = {};
  private showroomDaySelect: HTMLSelectElement | null;
  private showroomDayOptions: SelectOptionTemplates = {};

  private apiBaseUrl: string | undefined;

  bindings() {
    super.bindings();

    if (this.items) {
      Object.values(this.items).forEach((item: any) => {
        item.addEventListener('click', (e: Event) => {
          const target = e.currentTarget as HTMLElement;
          if (target && target.dataset.config) {
            const targetConfig = JSON.parse(target.dataset.config);
            this.loadFormByKey(targetConfig.form, targetConfig);
          }
        });
      });
    }

    document.addEventListener('formpopup:open', (e: Event) => {
      // @ts-ignore
      const targetConfig = e.detail;
      if (targetConfig) {
        this.loadFormByKey(targetConfig.form, targetConfig);
        this.onTrigger(targetConfig);
      }
    });

  }

  cache() {
    super.cache();
    this.formPopup = document.querySelector('#form-popup');
    this.formTitleEl = document.querySelector('#form-popup .m-popup__title');
    this.formContentEl = document.querySelector('#form-popup .m-popup__content');
    this.formSuccessEl = document.querySelector('#form-popup .m-popup__success');
    this.cartIconHeader = document.querySelector('.l-header__actions-button-cart .js-l-header__cart-icon');
    this.cartIconHeaderInner = this.cartIconHeader?.querySelector('tspan');
    this.apiBaseUrl = document.body.dataset.apiBaseUrl;
  }

  private async loadFormByKey(key: String, data: any) {
    if (this.isSending) return;

    let lang = '';
    const formData = new FormData();
    if (data) {
      for (let dataKey in data) {
        // @ts-ignore
        let dataVal = data[dataKey];
        formData.append(dataKey, dataVal);

        if (dataKey === 'hideMessageBox' && data[dataKey]) {
          this.showRequiredAccessoriesMessageBox = false;
        }
      }
    }

    let dataType = 'form';
    if (data.typ) {
      dataType = data.typ;
    }
    else if (data.type) {
      dataType = data.type;
    }
    if(data.lang) {
      lang = data.lang == 'default' ? '' : `/${data.lang}`;
    }

    const apiBaseUrl = document.body.dataset.apiBaseUrl;

    // @ts-ignore
    switch (dataType) {
      case 'flex':
        await fetch(`${apiBaseUrl}api/v1/modal/load/${key}`, {
          method: 'POST',
          body: formData
        })
          .then(response => response.json())
          .then(data => this.handleLoadedForm(data))
          .catch(error => this.handleLoadedForm(error));
        break;

      case 'form':
      case 'fix':
        await fetch(`${apiBaseUrl}api/v1/forms/load/${key}`, {
          method: 'POST',
          body: formData
        })
          .then(response => response.json())
          .then(data => this.handleLoadedForm(data))
          .catch(error => this.handleLoadedForm(error));
        //TODO load fixes modal
        break;
    }
  }

  private handleLoadedForm(data: any) {
    if (!data.success) {
      //TODO setup a backup if the choosen Form was not found
      alert('form-not-found');
    } else {
      // @ts-ignore
      this.formContentEl.innerHTML = data.html;
      // @ts-ignore
      this.formSuccessEl.innerHTML = data.success_message;
      // @ts-ignore
      this.formTitleEl.innerHTML = data.title;

      this.formToggleTrigger = this.formPopup?.querySelector('.js-o-modal-form__toggle-trigger');
      this.formToggleTarget = this.formPopup?.querySelectorAll('.js-o-modal-form__toggle-target');
      this.formOpenTrigger = this.formPopup?.querySelector('.js-o-modal-form__open-trigger');
      this.formOpenTarget = this.formPopup?.querySelector('.js-o-modal-form__open-target');
      this.successCloseBtn = this.formPopup?.querySelectorAll('.js-form-popup-link-close');
      const modalSliderEl = this.formContentEl?.querySelector('.js-modal-image-video__slider');

      this.buttonTabs = this.formPopup?.querySelectorAll('.js-form-tab-switch');
      this.tabColumn = this.formPopup?.querySelector('[data-key="company"]');
      this.inputCompany = this.formPopup?.querySelector('input[name="company"]');

      this.uploadButtons = this.formPopup?.querySelectorAll('.m-wishlist-popup-call-expert__file-upload input');
      this.addUploadButton = this.formPopup?.querySelector('.m-wishlist-popup-call-expert__file-upload-add-upload') || null;
      this.removeUploadButtons = this.formPopup?.querySelectorAll('.m-wishlist-popup-call-expert__file-upload-remove-upload');
      this.cachedFileInput = this.formPopup?.querySelector('.m-wishlist-popup-call-expert__file-upload-fields djx-grid-row')?.cloneNode(true);

      this.customerDeliveryAddressToggle = this.formPopup?.querySelector('.customerDeliveryAddressToggle') || null;
      this.customerProjectContactToggles = this.formPopup?.querySelectorAll('.toggle__content input[type="checkbox"]');

      this.showroomLocationInputs = this.formPopup?.querySelectorAll('input[name="location"]') || null;
      this.showroomDaySelect = this.formPopup?.querySelector('select[name="day"]') || null;
      this.showroomTimeSelect = this.formPopup?.querySelector('select[name="time"]') || null;

      (this.formPopup?.querySelectorAll('template.timeslot-options') as NodeListOf<HTMLTemplateElement>).forEach( (template: HTMLTemplateElement) => {
        this.showroomTimeOptions[template.dataset.availability as string] = template;
      })

      if (this.showroomLocationInputs && this.showroomTimeSelect) {
        this.handleDynamicShowroomTimesPerLocation();
      }

      (this.formPopup?.querySelectorAll('template.day-options') as NodeListOf<HTMLTemplateElement>).forEach( (template: HTMLTemplateElement) => {
        this.showroomDayOptions[template.dataset.availability as string] = template;
      })

      if (this.showroomLocationInputs && this.showroomDaySelect) {
        this.handleDynamicShowroomDaysPerLocation();
      }

      if (modalSliderEl) {
        const modalSlider = new ModalImageVideoSlider(modalSliderEl as HTMLElement);
        modalSlider.init();
      }

      if (this.formToggleTrigger) {
        this.formToggleTrigger.addEventListener('change', () => {
          this.formToggleTarget?.forEach(element => {
            element.classList.toggle('hidden');
            element.querySelectorAll('input, select').forEach(inputField => {
              if((inputField as HTMLInputElement).dataset.required) {
                let inputLabel = inputField.nextElementSibling as HTMLElement;
                (inputField as HTMLInputElement).required = !(inputField as HTMLInputElement).required;
                inputLabel.innerText = inputLabel.innerText.indexOf('*') >= 0 ? inputLabel.innerText.slice(0, -1) : inputLabel.innerText + '*';
              }
            });
          });
        })
      }


      if (this.customerDeliveryAddressToggle) {
        this.customerDeliveryAddressToggle.addEventListener('change', () => {
          // check before
          if (this.customerDeliveryAddressToggle && this.customerDeliveryAddressToggle instanceof HTMLInputElement) {
            const div = this.formPopup?.querySelector('.customerDeliveryAddressContent');

            if (div) {
              if (this.customerDeliveryAddressToggle.checked) {
                div.classList.remove('hidden');
              } else {
                div.classList.add('hidden');
              }
            }
          }
        });
      }


  // Handle customer project contact toggles
  this.customerProjectContactToggles?.forEach(toggle => {
    toggle.addEventListener('change', () => {
      // Find the parent .toggle__content div
      const parentDiv = toggle.closest('.toggle__content');
      if (parentDiv) {
        // Find the .toggle_hidden__content div within the parent
        const hiddenContentDiv = parentDiv.querySelector('.toggle_hidden__content');
        if (hiddenContentDiv) {
          // Toggle the 'hidden' class based on the checkbox state
          hiddenContentDiv.classList.toggle('hidden', !toggle.checked);
        }
      }
    });
  });


      if (this.formOpenTrigger) {
        this.formOpenTrigger.addEventListener('click', () => {
          this.formOpenTarget?.classList.remove('hidden');
        })
      }

      this.createAccountCheckbox = this.formPopup?.querySelector('input[name="create_account"]') as HTMLInputElement;
      let accountPasswordInputs = this.formPopup?.querySelectorAll('.l-form-m__account-i') as NodeListOf<HTMLInputElement>;

      if (this.createAccountCheckbox) {
        this.createAccountCheckbox.addEventListener('change', () => {
          this.formPopup?.classList.toggle('is-account-required');

          accountPasswordInputs.forEach(passwordInput => {
            passwordInput.required = !passwordInput.required;
          });
        });
        accountPasswordInputs[0].focus();
      }

      // Specifc action for required-accessories modal
      if (this.formPopup?.querySelector('form[name="required-accessories"]')) {
        this.handleRequiredAccessoriesForm();

        const observer = new MutationObserver((mutationList) => {
          let triggered = false;
          for (const mutation of mutationList) {
            if (!triggered && mutation.type === 'attributes' && mutation.attributeName === 'class') {
              if (!(mutation.target as HTMLElement).classList.contains('m-popup--is-active')) {
                triggered = true;
                observer.disconnect();
                window.dispatchEvent(new Event('required-accessories:close'));
                // @ts-ignore
                this.formContentEl.innerHTML = '';
              }
            }
          }
        });

        observer.observe((this.formPopup as Node), {attributes: true, attributeFilter: ['class']});
      }

      if(this.buttonTabs && this.buttonTabs.length) {
        this.buttonTabs[0].addEventListener('click', (e) => this.toggleInputCompany(e, false));
        this.buttonTabs[1].addEventListener('click', (e) => this.toggleInputCompany(e, true));
      }

      if (this.uploadButtons) {
        this.uploadButtons.forEach((input) => input.addEventListener('change', this.setFilename.bind(this)));
      }

      if (this.addUploadButton) {
        this.addUploadButton.addEventListener('click', this.addUpload.bind(this));
      }

      if (this.removeUploadButtons) {
        this.removeUploadButtons.forEach((button) => button.addEventListener('click', this.removeUpload.bind(this)));
      }

      //const linkClose = this.formContentEl?.querySelector('.js-form-popup-link-close');

      this.successCloseBtn?.forEach(element => {
        element.addEventListener('click', (event) => {
          document.body.classList.remove('m-popup--is-visible');
          document.querySelector('.m-popup--is-active')?.classList.remove('m-popup--is-active');
          this.formPopup?.classList.remove('success');
          event?.preventDefault();
        });
      });

      var forms = this.formContentEl?.querySelectorAll('form');
      if (forms) {
        forms.forEach(form => {
          var formVal = new FormValidation(form, this.onSubmit.bind(this));
          formVal.init();
        })
        var tabs = new Tabs();
        tabs.init();
      }

      window.addEventListener('popup:close', () => {
        // @ts-ignore
        this.formContentEl.innerHTML = '';
        // @ts-ignore
        this.formSuccessEl.innerHTML = '';
        // @ts-ignore
        this.formTitleEl.innerHTML = '';
      }, {once: true});
    }

    this.isSending = false;
  }

  private async onSubmit(formEl: HTMLFormElement) {
    if (this.isSending) return;

    formEl.classList.add('loading');
    this.toggleFormError();

    var formData = new FormData(formEl);

    if (!this.showRequiredAccessoriesMessageBox) {
      formData.append('hideMessageBox', 'true');
    }

    if ((this.createAccountCheckbox as HTMLInputElement)?.checked) {
      let password = this.formPopup?.querySelector('input[name="password"]') as HTMLInputElement;
      let passwordRepeat = this.formPopup?.querySelector('input[name="password-repeat"]') as HTMLInputElement;

      if (password.value === passwordRepeat.value && password.value !== '') {
        this.createAccount = true;
      } else {
        messageBoxError({
          contentDe: 'Es ist ein Fehler aufgetreten. Bitte überprüfe Deine Passwörter.',
          contentEn: 'An error appeared. Please check your passwords.',
        });

        password.classList.add('has-error');
        passwordRepeat.classList.add('has-error');
        password.addEventListener('keydown', () => password.classList.remove('has-error'));
        passwordRepeat.addEventListener('keydown', () => passwordRepeat.classList.remove('has-error'));
      }
    }

    if (this.createAccount) {
      const accountCreated = await this.createAccountFunction();
    }
    let successful = false;

    switch (true) {
      case (/download-pw/).test(formEl.action):
        const downloadPasswordResult = await this.handleDownloadPasswordRequest(formEl, formData, true);
        break;

      // @ts-ignore
      case formEl.action && formEl.action?.value && (/add-to-cart/).test(formEl.action?.value):
        await this.handleDefaultRequest(formEl, formData);
        break;

      case formEl.action && (/open-config-sales-email/).test(formEl.name):
        this.handleOpenConfigSalesEmail(formEl, formData);
        break;

      case formEl.action && (/open-config/).test(formEl.name):
        this.handleOpenConfigRequest(formEl, formData);
        break;

      case (/forms\/download\/id/).test(formEl.action):
        if(document.body.classList.contains('is-user')) {
          const downloadResult = await this.handleDownloadPasswordRequest(formEl, formData, false);
          break;
        }

      default:
        const defaultResult = await this.handleDefaultRequest(formEl, formData);
    }

    if (successful) {
      this.handleSubmitResponse({ "success": successful }, formEl);
    }
  }

  protected getEndpoint(formEl: HTMLFormElement, downloadProtected: Boolean): string {
    const apiBaseUrl = document.body.dataset.apiBaseUrl;
    const idFile = formEl.action.substring(formEl.action.indexOf('id/') + 3, formEl.action.indexOf('/lang'));
    const lang = formEl.action.substring(formEl.action.indexOf('lang/') + 5);
    const pwInput = formEl.querySelector('[name="password"]') as HTMLInputElement;
    if(downloadProtected) {
      const valBase64 = window.btoa(pwInput.value || '');
      return `${apiBaseUrl}api/v1/download/id/${idFile}/lang/${lang}/flex/${valBase64}`;
    }
    return `${apiBaseUrl}api/v1/download/id/${idFile}/lang/${lang}`;
  }

  private toggleFormError(setError: boolean = false) {
    const form = this.formPopup?.querySelector('form') as HTMLFormElement;
    const errorMessageContainer = form.querySelector('.error-message') as HTMLElement;
    if(form.dataset.error) {
      const errorMessage = form.dataset.error || errorMessageContainer.dataset.errorDefault;
      if(setError) {
        form.classList.add('has-error');
        if(errorMessage) errorMessageContainer.innerText = errorMessage;
        errorMessageContainer.classList.remove('hidden');
      } else {
        form.classList.remove('has-error');
        errorMessageContainer.classList.add('hidden');
      }
    }
  }

  private handleSubmitResponse(data: any, formEl: HTMLFormElement) {
    if (data != null && data.blob && data.blob.type && data.blob.type === 'application/pdf') {
      const file = window.URL.createObjectURL(data.blob);
      const a = document.createElement('a');
      a.href = file;
      a.download = data.headers.get('Content-Disposition')?.split('filename=')[1] || file.substr(file.lastIndexOf('/') + 1);
      document.body.appendChild(a);
      a.style.display = 'none';
      a.click();
      document.body.removeChild(a);
      data = { success: true };
    }
    if (data != null && (!data.success || data.success == 'false')) {
      formEl.classList.remove('loading');
      messageBoxError({
        contentDe: 'Es ist ein Fehler aufgetreten',
        contentEn: 'an error appeared',
      });
      if (data.message == 'download.wrong_password') {
        this.toggleFormError(true);
        //this.formPopup?.querySelector('.error-message')?.innerHTML = (this.formPopup?.querySelector('.o-form') as HTMLElement).dataset.error;
      }

      let errors = data.errors;
      // For each errors keys find the corresponding input and set the error class
      if (errors) {
        for (let key in errors) {
        let input = formEl.querySelector('[name="' + key + '"]') as HTMLInputElement;
          if (input) {
            this.handleInputErrorDecoration(input);
            input.focus();
          }
        }
      }

    } else {
      if (formEl.querySelector('input[name="update-cart"]')) {
        let updateCartEvent = new CustomEvent('cart:updated', {
          detail: { showCart: true },
        } as any);
        document.dispatchEvent(updateCartEvent);

        if (data.message) {
          messageBoxSuccess({
            contentDe: data.message,
            contentEn: data.message,
          });
        }

        // Update header icon cart totals
        if (this.cartIconHeaderInner) {
          let sum = 0;
          let alreadyCounted: any[] = [];
          data.cart.lineItems.forEach((lineItem: any) => {
            if (!lineItem.options?._configuratorId || lineItem.options?._configuratorMainItem === 'yes') {
              sum += lineItem.qty;
            }
            alreadyCounted.push(lineItem.options?._configuratorId);
          });
          this.cartIconHeaderInner.innerHTML = String(sum);
        }

        document.body.classList.remove('m-popup--is-visible');
        document.querySelector('.m-popup--is-active')?.classList.remove('m-popup--is-active');
      }
      else {
        this.formPopup?.classList.add('success');
        if(formEl.action.indexOf('contact') != -1) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ lead: null }); // reset data layer items
          window.dataLayer.push({
            event: 'generate_lead',
            lead: {
              type: 'form_contact',
              email: data.validated_data.email, // email entered in contact form
              new_lead: data.hasOwnProperty('is_first_contact') && data.is_first_contact ? 'Yes' : 'No'
            }
          });
        }
        if(formEl.action.indexOf('default') != -1 && data != null && data.validated_data != null && data.validated_data.modal_name != null) {
          switch (true) {
            case data.validated_data.modal_name.search(/samples/i) != -1:
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ lead: null }); // reset data layer items
              window.dataLayer.push({
                event: 'generate_lead',
                lead: {
                  type: 'form_samples',
                  email: data.validated_data.email,
                  new_lead: data.hasOwnProperty('is_first_contact') && data.is_first_contact ? 'Yes' : 'No'
                }
              });
              break;
            // TODO: Has this moved?
            case data.validated_data.modal_name.search(/download/i) != -1:
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ lead: null });
              window.dataLayer.push({
                event: 'generate_lead',
                lead: {
                  type: 'form_download',
                  email: data.validated_data.email,
                  content_type: 'file',
                  file_title: data.hasOwnProperty('file_title') ? data.file_title : 'unknown',
                  new_lead: data.hasOwnProperty('is_first_contact') && data.is_first_contact ? 'Yes' : 'No'
                }
              });
              break;
            case data.validated_data.modal_name.search(/showroom/i) != -1:
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ lead: null });
              window.dataLayer.push({
                event: 'generate_lead',
                method: data.validated_data.location == 'online' ? 'remote' : 'inhouse',
                lead: {
                  type: 'schedule_showroom',
                  email: data.validated_data.email,
                  new_lead: data.hasOwnProperty('is_first_contact') && data.is_first_contact ? 'Yes' : 'No'
                }
              });
              break;
            case data.validated_data.modal_name.search(/samplebox/i) != -1:
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ lead: null });
              window.dataLayer.push({
                event: 'generate_lead',
                lead: {
                  type: 'form_sample_box',
                  email: data.validated_data.email,
                  new_lead: data.hasOwnProperty('is_first_contact') && data.is_first_contact ? 'Yes' : 'No'
                }
              });
              break;
            // TODO: Has this moved?
            case data.validated_data.modal_name.search(/expertenberatung/i) != -1:
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ lead: null });
              window.dataLayer.push({
                event: 'generate_lead',
                lead: {
                  type: 'schedule_consulting',
                  email: data.validated_data.email,
                  new_lead: data.hasOwnProperty('is_first_contact') && data.is_first_contact ? 'Yes' : 'No'
                }
              });
              break;
          }
        }


      }
    }
    this.isSending = false;
  }

  private handleInputErrorDecoration(input: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement, errorMessage: string = '') {
    if (!input.classList.contains('has-error')) {
      input.classList.add('has-error');
      const errorMessageDiv = document.createElement('div');
      errorMessageDiv.classList.add('error-message');
      errorMessageDiv.innerText = errorMessage ? errorMessage : input.dataset.errorMessage ?? '* Pflichtfeld';

      input.parentElement?.appendChild(errorMessageDiv);

      const eventListenerType = ['checkbox', 'radio', 'select', 'select-one'].includes(input.type) ? 'change' : 'keyup';

      input.addEventListener(eventListenerType, () => {
        // @ts-ignore
        if ((input.value && input.minLength === -1) || (input.value && input.minLength !== -1 && input.value.length >= input.minLength) || input.checked || (!input.value && !input.required)) {
          input.classList.remove('has-error');
          errorMessageDiv.classList.add('is-hidden');
        } else {
          input.classList.add('has-error');
          errorMessageDiv.classList.remove('is-hidden');
        }
      });
    }
  }

  async handleDefaultRequest(formEl: HTMLFormElement, formData: FormData) {
    let formAction = formEl.action;
    // @ts-ignore
    if (formEl.action && formEl.action?.value) {
      await fetch(this.apiBaseUrl!, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: formData,
      })
        .then(async (response) => {
          if(response.headers.get('Content-Disposition') !== null) {
            return {
              headers: response.headers,
              blob: await response.blob()
            };
          }
          return response.json()
        })
        .then(data => this.handleSubmitResponse(data, formEl))
        .catch(error => this.handleSubmitResponse(error, formEl));
    }
    else {
      await fetch(formAction, {
        method: 'POST',
        body: formData
      })
        .then(async (response) => {
          if(response.headers.get('Content-Disposition') !== null) {
            return {
              headers: response.headers,
              blob: await response.blob()
            };
          }
          return response.json()
        })
        .then(data => this.handleSubmitResponse(data, formEl))
        .catch(error => this.handleSubmitResponse(error, formEl));
    }
  }

  async handleDownloadPasswordRequest(formEl: HTMLFormElement, formData: FormData, downloadProtected: Boolean = true) {
    await fetch(this.getEndpoint(formEl, downloadProtected), {
      method: 'GET',
    })
      .then((response) => {
        const filename = `${formData.get('file_name')}.pdf`;
        if (response.headers.get('Content-Disposition') !== null && response.status == 200) {
          return response.blob().then((blob) => {
            const file = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = file;
            a.download = filename ?? file.substr(file.lastIndexOf('/') + 1);
            document.body.appendChild(a);
            a.style.display = 'none';
            a.click();
            document.body.removeChild(a);
            //successful = true;
            return { success: true };
          });
        }
        return response.json();
      })
      .then(data => this.handleSubmitResponse(data, formEl))
      .catch(error => this.handleSubmitResponse(error, formEl));
  }

  async handleOpenConfigSalesEmail(formEl: HTMLFormElement, formData: FormData) {
    let bodyData = null;
    const apiBaseUrl = document.body.dataset.apiBaseUrl;
    const email = formData.get('email')?.toString();
    const quotationNumber = formData.get('quotationNumber')?.toString();

    if (email && email.length > 0) {
      bodyData = {
        'entryId': (formEl.querySelector('button[type="submit"]') as HTMLButtonElement || null)?.dataset.entryId,
        'email': email,
      };
    }
    else if (quotationNumber && quotationNumber.length > 0) {
      bodyData = {
        'entryId': (formEl.querySelector('button[type="submit"]') as HTMLButtonElement || null)?.dataset.entryId,
        'quotationNumber': quotationNumber,
      };
    }

    if (bodyData != null) {
      const getEntryRequestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(bodyData),
      };
      // @ts-ignore
      const res = await fetch(apiBaseUrl + 'api/v1/roomle/create-client-offer', getEntryRequestOptions);
      const jsonRes = await res.json();

      formEl.classList.remove('loading');

      if (jsonRes.success) {
        messageBoxSuccess({
          contentDe: jsonRes.message,
          contentEn: jsonRes.message,
        });
      } else {
        messageBoxError({
          contentDe: jsonRes.message,
          contentEn: jsonRes.message,
        });
      }
    }
  }

  async handleOpenConfigRequest(formEl: HTMLFormElement, formData: FormData) {
    const getEntryRequestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        'item_id': (formData.get('config') as string | null)?.replace('#', ''),
      }),
    };
    const apiBaseUrl = document.body.dataset.apiBaseUrl;
    // @ts-ignore
    const res = await fetch(apiBaseUrl + 'api/v1/roomle/get-roomle-config-entry-data', getEntryRequestOptions);
    const jsonRes = await res.json();

    formEl.classList.remove('loading');

    if (jsonRes.success && jsonRes.type === 'pro') {
      this.renderProHint(formEl, jsonRes);
      return;
    }

    if (!jsonRes.success) {
      this.toggleFormError(true);
    } else {
      window.location.href = `${jsonRes.url}`;
    }
  }

  private renderProHint(formEl: HTMLFormElement, jsonRes: { contactUrl: string; messageDe: string; messageEn: string }) {
    const isEn = document.documentElement.lang === 'en-US';
    const message = isEn ? jsonRes.messageEn : jsonRes.messageDe;
    const contactLabel = isEn ? 'Get in touch' : 'Kontakt aufnehmen';
    const backLabel = isEn ? 'Back' : 'Zurück';

    const existingHint = formEl.parentElement?.querySelector('.js-pro-hint') as HTMLElement | null;
    existingHint?.remove();

    formEl.style.display = 'none';
    this.toggleFormError();

    const hint = document.createElement('div');
    hint.className = 'js-pro-hint pt-6';
    hint.innerHTML = `
      <djx-grid-row>
        <djx-grid-col class="col-xs-24 col-lg-20 col-lg-offset-2 align-center">
          <div class="o-modal-text align-center mb-6">
            <div class="o-modal-text__inner">
              <p class="o-modal-text__content js-pro-hint-text">${message}</p>
            </div>
          </div>
          <a href="${jsonRes.contactUrl}" class="a-button a-button--black">
            ${contactLabel}
          </a>
          <div class="mt-3">
            <button type="button" class="js-pro-hint-back a-link" style="background:none;border:0;padding:0;font-size:16px;color:#666666;cursor:pointer;">${backLabel}</button>
          </div>
        </djx-grid-col>
      </djx-grid-row>
    `;
    formEl.insertAdjacentElement('afterend', hint);

    const messageEl = hint.querySelector('.js-pro-hint-text') as HTMLElement | null;
    if (messageEl) {
      messageEl.style.color = '#ff7276';
    }

    const backButton = hint.querySelector('.js-pro-hint-back') as HTMLButtonElement | null;
    backButton?.addEventListener('click', () => {
      hint.remove();
      formEl.style.display = '';
      const configInput = formEl.querySelector('input[name="config"]') as HTMLInputElement | null;
      if (configInput) {
        configInput.value = '';
        configInput.focus();
      }
    });
  }

  async createAccountFunction() {
    let success = false;
    const data = new FormData();

    // @ts-ignore
    data.append(window.csrfTokenName, window.csrfTokenValue);
    data.append('action', 'users/save-user');

    let salutation = this.formPopup?.querySelector('select[name="salutation"]');
    if (salutation instanceof HTMLSelectElement) {
      data.append('fields[salutation]', salutation.value);
      data.append('address[fields][addressTitle]', salutation.value);
    }

    let fullName = '';
    let firstName = this.formPopup?.querySelector('input[name="firstName"]');
    if (firstName instanceof HTMLInputElement) {
      data.append('firstName', firstName.value);
      data.append('fields[firstName]', firstName.value);
      data.append('address[firstName]', firstName.value);
      fullName = firstName.value;
    }

    let lastName = this.formPopup?.querySelector('input[name="lastName"]');
    if (lastName instanceof HTMLInputElement) {
      data.append('lastName', lastName.value);
      data.append('fields[lastName]', lastName.value);
      data.append('address[lastName]', lastName.value);
      fullName = fullName + ' ' + lastName.value;
    }

    data.append('fullName', fullName);
    data.append('fields[fullName]', fullName);
    data.append('address[fullName]', fullName);

    let email = this.formPopup?.querySelector('input[name="email"]');
    if (email instanceof HTMLInputElement) {
      data.append('email', email.value);
      data.append('fields[email]', email.value);
    }

    let phone = this.formPopup?.querySelector('input[name="phoneNumber"]');
    if (phone instanceof HTMLInputElement) {
      data.append('fields[phone]', phone.value);
      data.append('address[fields][phoneNumber]', phone.value);
    }

    let organization = this.formPopup?.querySelector('input[name="organization"]');
    let company = this.formPopup?.querySelector('input[name="company"]');
    if (organization instanceof HTMLInputElement) {
      data.append('fields[companyName]', organization.value);
      data.append('address[organization]', organization.value);
    }
    else if (company instanceof HTMLInputElement) {
      data.append('fields[companyName]', company.value);
      data.append('address[organization]', company.value);
    }

    let postalCode = this.formPopup?.querySelector('input[name="postalCode"]');
    if (postalCode instanceof HTMLInputElement) {
      data.append('address[postalCode]', postalCode.value);
    }

    let locality = this.formPopup?.querySelector('input[name="locality"]');
    if (locality instanceof HTMLInputElement) {
      data.append('address[locality]', locality.value);
    }

    let street = this.formPopup?.querySelector('input[name="street"]');
    if (street instanceof HTMLInputElement) {
      data.append('address[addressLine1]', street.value);
    }

    let notes = this.formPopup?.querySelector('input[name="addressNotes"]');
    if (notes instanceof HTMLInputElement) {
      data.append('address[fields][addressNotes]', notes.value);
    }

    let country = this.formPopup?.querySelector('select[name="country"]');
    if (country instanceof HTMLSelectElement) {
      data.append('address[countryCode]', country.value);
    }

    let password = this.formPopup?.querySelector('input[name="password"]');
    if (password instanceof HTMLInputElement) {
      data.append('password', password.value);
    }

    await fetch(this.apiBaseUrl!, {
      method: 'post',
      headers: {
        Accept: 'application/json',
      },
      body: data,
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.id && res.id != "") {
          success = true;
          messageBoxSuccess({
            contentDe: 'Account angelegt',
            contentEn: '',
          });

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'sign_up',
            user: {
              email: data.get('email')
            }
          });
        } else {
          throw new Error(JSON.stringify(res.errors));
        }
      })
      .catch((error) => {
        console.error(error);

        messageBoxError({
          contentDe: error,
          contentEn: '',
        });
      });
    return success;
  }

  private handleRequiredAccessoriesForm() {
    const form = this.formPopup?.querySelector('form[name="required-accessories"]');
    const variantSelects = form?.querySelectorAll('select[name="variant"]') as NodeListOf<HTMLSelectElement>;

    variantSelects.forEach((selectItem) => {
      const rowIndex = selectItem.dataset.index;
      const item = selectItem.closest('.o-required-accessories_products_item') as HTMLElement;

      selectItem.addEventListener('change', () => {
        var selectedVariantId = selectItem.value;

        var selectedVariantIdInput = form?.querySelector('input[name="product[' + rowIndex + '][required_accessory]"]') as HTMLInputElement;
        var purchaseableVariantInputId = form?.querySelector('#required_accessory_' + rowIndex + '_id') as HTMLInputElement;
        var purchaseableVariantInputSku = form?.querySelector('#required_accessory_' + rowIndex + '_sku') as HTMLInputElement;

        var selectedVariantInput = form?.querySelector('input[name="product[' + rowIndex + '][required_accessory][' + selectedVariantId + ']"]') as HTMLInputElement;
        var selectedVariant = JSON.parse(selectedVariantInput.value);

        var itemBgImage = item.querySelector('.o-required-accessories_products_item--image') as HTMLElement;
        var itemTitle = item.querySelector('.o-required-accessories_products_item--title--inner') as HTMLElement;
        var itemDescription = item.querySelector('.o-required-accessories_products_item--description') as HTMLElement;
        var itemColorImage = item.querySelector('.o-product-detail__options-item__preview') as HTMLElement;
        var itemPrice = item.querySelector('.js-product-price') as HTMLElement;

        if (itemBgImage && selectedVariant.image) {
          itemBgImage.style.backgroundImage = "url('" + selectedVariant.image + "')";
        }

        if (itemTitle && selectedVariant.title) {
          itemTitle.innerHTML = selectedVariant.title;
        }

        if (itemDescription && selectedVariant.description) {
          itemDescription.innerHTML = selectedVariant.description;
        }

        if (itemPrice && selectedVariant.price) {
          itemPrice.innerHTML = selectedVariant.price;
        }

        if (itemColorImage && selectedVariant.color) {
          itemColorImage.style.backgroundImage = "url('" + selectedVariant.color + "')";
        }

        if (selectedVariantIdInput && selectedVariant.id) {
          selectedVariantIdInput.value = selectedVariant.id;
        }
        if (purchaseableVariantInputId && selectedVariant.id) {
          purchaseableVariantInputId.value = selectedVariant.id;
        }
        if (purchaseableVariantInputSku && selectedVariant.sku) {
          purchaseableVariantInputSku.value = selectedVariant.sku;
        }
      });
    });
  }

  private toggleInputCompany(e: MouseEvent, isActive: boolean) {
    const { buttonTabs, tabColumn, inputCompany } = this;
    let tabColumnNeighbor = tabColumn ? tabColumn.nextElementSibling : null;
    if(buttonTabs && tabColumnNeighbor && tabColumn && inputCompany) {
      buttonTabs.forEach( (buttonTab) => buttonTab.classList.remove('is--active'));
      (e.target as HTMLElement).classList.add('is--active');

      inputCompany.value = '';
      if (isActive) {
        inputCompany.setAttribute('required', '');
        tabColumn.classList.remove('hidden');
        if(tabColumnNeighbor.classList.contains('col-lg-11')) {
          tabColumnNeighbor?.classList.add('col-lg-offset-2');
        } else {
          let i = 0;
          while(tabColumnNeighbor) {
            if( i % 3 == 0) {
              tabColumnNeighbor?.classList.remove('col-lg-offset-0');
              tabColumnNeighbor?.classList.add('col-lg-offset-1');
            }
            if( i % 3 == 2){
              tabColumnNeighbor?.classList.remove('col-lg-offset-1');
              tabColumnNeighbor?.classList.add('col-lg-offset-0');
            }
            if( i % 2 == 0) {
              tabColumnNeighbor?.classList.remove('col-md-offset-2');
              tabColumnNeighbor?.classList.add('col-md-offset-0');
            }
            if( i % 2 == 1) {
              tabColumnNeighbor?.classList.remove('col-md-offset-0');
              tabColumnNeighbor?.classList.add('col-md-offset-2');
            }
            tabColumnNeighbor = tabColumnNeighbor.nextElementSibling;
            i++;
          }
        }
      } else {
        inputCompany.removeAttribute('required');
        tabColumn.classList.add('hidden');
        if(tabColumnNeighbor.classList.contains('col-lg-11')) {
          tabColumnNeighbor?.classList.remove('col-lg-offset-2');
        } else {
          let i = 0;
          while(tabColumnNeighbor) {
            if( i % 3 == 0) {
              tabColumnNeighbor?.classList.remove('col-lg-offset-1');
              tabColumnNeighbor?.classList.add('col-lg-offset-0');
            }
            if( i % 3 == 2) {
              tabColumnNeighbor?.classList.remove('col-lg-offset-0');
              tabColumnNeighbor?.classList.add('col-lg-offset-1');
            }
            if( i % 2 == 0) {
              tabColumnNeighbor?.classList.remove('col-md-offset-0');
              tabColumnNeighbor?.classList.add('col-md-offset-2');
            }
            if( i % 2 == 1) {
              tabColumnNeighbor?.classList.remove('col-md-offset-2');
              tabColumnNeighbor?.classList.add('col-md-offset-0');
            }
            tabColumnNeighbor = tabColumnNeighbor.nextElementSibling;
            i++;
          }
        }
      }
    }
  }

  setFilename(e: Event) {
    const target = e.currentTarget as HTMLInputElement;

    if (target.files) {
      if (target.files[0].size > 5000000) {
        messageBoxError({
          contentDe: 'Die Datei ist leider zu groß (> 5MB).',
          contentEn: 'The file is too big (> 5MB).',
        });

        // @ts-ignore
        target.value = null;
      }

      if (target.files) {
        const fileTypes = [
          'image/apng',
          'image/jpeg',
          'image/pjpeg',
          'image/png',
          'image/tiff',
          'image/webp',
          'application/pdf',
        ];

        if (!fileTypes.includes(target.files[0].type)) {
          messageBoxError({
            contentDe: 'Ungültiger Dateityp (erlaubt: Bilder, PDF).',
            contentEn: 'Invalid filetype (allowed: images, pdf).',
          });

          // @ts-ignore
          target.value = null;
        }
      }
    }

    if (target.files && target.nextElementSibling) {
      target.nextElementSibling.innerHTML = target.files[0].name;
    }
  }

  addUpload() {
    const container: HTMLElement | null | undefined = this.formPopup?.querySelector('.m-wishlist-popup-call-expert__file-upload-fields');
    const lastInput: HTMLElement | null | undefined = container?.querySelector('djx-grid-row:last-of-type input');

    if (this.cachedFileInput) {
      const clone = this.cachedFileInput.cloneNode(true);
      const input = (clone as HTMLElement).querySelector('input');
      if (input) {
        const newIndex = Number(lastInput?.dataset.index) || 0;
        input.name = `file-${newIndex + 1}`;
        input.dataset.index = `${newIndex + 1}`;
      }
      container?.appendChild(clone);
    }

    this.removeUploadButtons = this.formPopup?.querySelectorAll('.m-wishlist-popup-call-expert__file-upload-remove-upload');
    this.removeUploadButtons?.forEach((button) => {
      button.addEventListener('click', this.removeUpload.bind(this));
      button.disabled = false;
    });
    this.uploadButtons = this.formPopup?.querySelectorAll('.m-wishlist-popup-call-expert__file-upload input');
    this.uploadButtons?.forEach((input) => input.addEventListener('change', this.setFilename.bind(this)));
  }

  removeUpload(e: Event) {
    const target = e.currentTarget as HTMLElement;
    const elementToRemove = target.closest('djx-grid-row');

    elementToRemove?.parentElement?.removeChild(elementToRemove);

    this.removeUploadButtons = this.formPopup?.querySelectorAll('.m-wishlist-popup-call-expert__file-upload-remove-upload');

    if (this.removeUploadButtons?.length === 1) {
      this.removeUploadButtons[0].disabled = true;
    }
  }

  init() {
    this.selectorClass = 'form-popup';
    this.cache();
    this.bindings();
  }

  private handleDynamicShowroomTimesPerLocation() {
    const updateOptions = (availability: string = '') => {
      if (!this.showroomTimeSelect) {
        return;
      }

      this.showroomTimeSelect.value = '';
      this.showroomTimeSelect.innerHTML = '';

      const options = this.showroomTimeOptions[availability]?.content?.cloneNode(true) as Node;

      this.showroomTimeSelect.appendChild(options)
    }

    const setCurrentLocationsTimeslotOptions = () => {
      this.showroomLocationInputs?.forEach((input) => {
        if (input.checked) {
          updateOptions(input.value);
        }
      });
    }

    setCurrentLocationsTimeslotOptions();

    // Switch timeslot options based on location change.
    this.showroomLocationInputs?.forEach((input) => {
      input.addEventListener('change', (e) => {
        updateOptions((e.target as HTMLInputElement)?.value);
      })
    });


    // Switch time slot options based on day change.
    // If Saturday was chosen, switch to Saturday options.
    // If there was a switch from Saturday to a day that is not Saturday, switch to the current locations options.
    // Otherwise, don't switch anything.
    let previousSelectedDay = this.showroomDaySelect?.value
    this.showroomDaySelect?.addEventListener('change', e => {
      let selectedDay = (e.target as HTMLSelectElement).value;

      if (selectedDay === 'samstag') {
        updateOptions(selectedDay)
      }

      if (previousSelectedDay === 'samstag') {
        setCurrentLocationsTimeslotOptions()
      }

      previousSelectedDay = selectedDay;
    })
  }

  private handleDynamicShowroomDaysPerLocation() {
    const updateOptions = (locationValue: string = '') => {
      if (!this.showroomDaySelect) {
        return;
      }

      this.showroomDaySelect.value = '';
      this.showroomDaySelect.innerHTML = '';

      const options = this.showroomDayOptions[locationValue]?.content?.cloneNode(true) as Node;

      this.showroomDaySelect.appendChild(options)
    }

    this.showroomLocationInputs?.forEach((input) => {
      if (input.checked) {
        updateOptions(input.value);
      }

      input.addEventListener('change', (e) => {
        const locationValue = (e.target as HTMLInputElement)?.value;
        updateOptions(locationValue);
      })
    });
  }
}

export default FormPopup;
